import React, { Component } from 'react';
import Header from '/app/src/Header.js';
import Footer from '/app/src/Footer.js';

class Login extends Component {
  constructor() {
    super();
    this.state = { email: '', password: '', error: '', isLoading: false };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  async handleSubmit(e) {
    e.preventDefault();
    this.setState({ error: '', isLoading: true });

    try {
      const res = await fetch('/api/internal/login', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: this.state.email.trim(),
          password: this.state.password,
        }),
      });

      if (!res.ok) {
        throw new Error('Network error — try again later');
      }

      const data = await res.json();

      if (data.success) {
        this.props.history.replace('/');
      } else {
        throw new Error(data.error_message || 'Login failed');
      }
    } catch (err) {
      this.setState({ error: err.message || 'Server error', isLoading: false });
    }
  }

  render() {
    const { email, password, error, isLoading } = this.state;

    return (
      <div>
        <Header />
        <section className="section" style={{ maxWidth: 480, margin: '0 auto' }}>
          <h1 className="title">Login</h1>

          <form onSubmit={this.handleSubmit}>
            <div className="field">
              <label className="label">Email</label>
              <div className="control">
                <input
                  className="input"
                  type="text"
                  name="email"
                  value={email}
                  onChange={this.handleChange}
                  required
                  autoFocus
                  disabled={isLoading}
                />
              </div>
            </div>

            <div className="field">
              <label className="label">Password</label>
              <div className="control">
                <input
                  className="input"
                  type="password"
                  name="password"
                  value={password}
                  onChange={this.handleChange}
                  required
                  disabled={isLoading}
                />
              </div>
            </div>

            <p className="has-text-danger" style={{ minHeight: '1.5em' }}>
              {error || '\u00A0'}
            </p>

            <button
              className={`button is-primary is-fullwidth${isLoading ? ' is-loading' : ''}`}
              disabled={isLoading}
            >
              Log in
            </button>
          </form>
        </section>
        <Footer />
      </div>
    );
  }
}

export default Login;
